// =====================================
//
//   公告 modal
//   Author: Gray
//   createtime: 2018 / 02 / 07
//   updatetime: 2018 / 02 / 07
//
// =====================================

window.InifECMobileApp.directive('announcement', ['$rootScope', '$ngModal', '$localStorage', '$timeout', function ($rootScope, $ngModal, $localStorage, $timeout) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        // --------------------------------
        //  [private] 開啟 modal
        // --------------------------------
        var openModal = function() {

        	$ngModal.openModal('announcement-modal');
        }

        // --------------------------------
        //  [private] 關閉 modal
        // --------------------------------
        var closeModal = function() {

        	$ngModal.closeModal('announcement-modal');
        }

        // --------------------------------
        //  關閉
        // --------------------------------
        var cancel = function() {

            closeModal();
        }

        // --------------------------------
        //  切換是否今日再通知
        // --------------------------------
        var toggleNotify = function() {

            $scope.isNotify = !$scope.isNotify;
        }

        // --------------------------------
        //  [private] 更新localStorage
        // --------------------------------
        var updateNotifyLocalStorage = function() {

            if($scope.isNotify) {
                var now = new Date();
                var dd = now.getDate();
                var mm = now.getMonth() + 1;
                var yyyy = now.getFullYear();
                
                yyyy = yyyy.toString();
                mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
                dd = (dd < 10) ? '0' + dd.toString() : dd.toString();

                var nowString = yyyy + mm + dd;

                $localStorage.announcement = nowString;
            }
        }

        // --------------------------------
        //  [private] init
        // --------------------------------
        var init = function() {

            var now = new Date();
            var dd = now.getDate();
            var mm = now.getMonth() + 1;
            var yyyy = now.getFullYear();
            var day = now.getDay();

            yyyy = yyyy.toString();
            mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
            dd = (dd < 10) ? '0' + dd.toString() : dd.toString();

            var nowString = yyyy + mm + dd;

            // 是否再提醒
            // if($localStorage.announcement) {
            //     var announcementInt = parseInt($localStorage.announcement);

            //     if(announcementInt >= 20180828) {
            //         return;
            //     }
            // }

            var nowInt = parseInt(nowString);

            if(nowInt <= 20190210) {

                var announcementCount = 0;

                if($localStorage.announcementCountMap) {
                    if($localStorage.announcementCountMap['2019year']) {
                        announcementCount = Number($localStorage.announcementCountMap['2019year']);
                    }
                } else {
                    $localStorage.announcementCountMap = {};
                }

                if(announcementCount >= 2) {
                    return;
                }

                $localStorage.announcementCountMap['2019year'] = announcementCount + 1;

                openModal();
            }
        }

        /*==========================
            Events
        ==========================*/            
        $scope.$on('OPEN_ANNOUNCEMENT_MODAL', function(event, data) {

            init();
        });

        $scope.$on('CLOSE_MODAL_COMPLETE', function(event, modalName) {

            if(modalName == 'announcement-modal') {
                updateNotifyLocalStorage();
            }
        });

        /*==========================
            Members
        ==========================*/
        $scope.isNotify;
        $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;
        
        $localStorage.$default({
            announcement: undefined,
            announcementCount: '0',
            announcementCountMap: {
                '2019year': '0',
            },
        });

        /*==========================
            Methods
        ==========================*/
        $scope.cancel = cancel; //  關閉
        $scope.toggleNotify = toggleNotify; // 切換是否今日再通知
        
        /*==========================
            init
        ==========================*/
        $timeout(function() {
            init();
        }, 2000);
	}]

	_dir.restrict = "E";
	_dir.scope = true;
	_dir.templateUrl = "mobile/partials/modal/announcement.html";
	_dir.controller = controller;

	return _dir;
}]);